import { MAX_FILE_SIZE } from '@constants/pdf.constants';
import { DocumentJobError } from '@domain/types';
import { logger } from '@services/logger/logger.service';
import { checkFileFormat } from '@services/pdf/checkFileFormat';

const A1_WIDTH = 2384;

export const hasPdfExtension = (fileName: string): boolean => {
  const splitted = fileName.toLowerCase().split('.');
  return splitted[splitted.length - 1] === 'pdf';
};

const isFileSizeOk = (file: Buffer): boolean => {
  const fileSizeInMo = file.buffer.byteLength / 1000000;
  return fileSizeInMo < MAX_FILE_SIZE;
};

export const checkFileForErrors = async (
  file: Buffer,
  fileName: string,
  options?: {
    maxPageNumber?: number;
    offsetSizePage?: number;
    allowFileWithRotate?: boolean;
    maxWidth?: number;
    maxHeight?: number;
  },
): Promise<DocumentJobError[]> => {
  const errors: DocumentJobError[] = [];
  try {
    if (!isFileSizeOk(file)) {
      return [DocumentJobError.FileSizeTooBig];
    }
    if (!hasPdfExtension(fileName)) {
      return [DocumentJobError.WrongFileType];
    }
    const formatCheck = await checkFileFormat(
      file,
      options?.maxPageNumber,
      options?.offsetSizePage,
      options?.allowFileWithRotate,
      options?.maxWidth,
      options?.maxHeight,
    );
    if (formatCheck.tooManyPages) {
      errors.push(DocumentJobError.TooManyPages);
    }
    if (formatCheck.hasOnePageTooBig) {
      errors.push(
        options?.maxWidth === A1_WIDTH ? DocumentJobError.IsNotA1 : DocumentJobError.IsNotA4,
      );
    }
  } catch (err) {
    logger.error('LOGIC', 'PDF validation failed', err);
    return [DocumentJobError.CorruptedFile];
  }

  return errors;
};
